import { Component, OnInit, OnChanges, OnDestroy, ViewChild, Input, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService, CommonService, DashboardService } from '../../../services';
import { User } from '../../../models/UserObj';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserPreference } from '../../../models/UserPreference';
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  outputs: ['FacilityChanged', 'WidgetAdded']
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() Loading: boolean;
  public FacilityChanged: EventEmitter<any> = new EventEmitter<any>();

  userPref: UserPreference;
  @ViewChild('facility') facilityModal;
  facilityModalRef: NgbModalRef;
  user: User;
  breadcrumb: string;
  facilities: Array<any>;
  selFacilityId: string;
  selFacilityName: string;
  customers: Array<any>;
  selCustomerId: string;
  selCustomerName: string;
  loading: boolean = false;
  commonService: CommonService;
  IsAdmin: boolean = false;

  constructor(private _authService: AuthService,
    private _commonService: CommonService,
    private _dashboardService: DashboardService,
    private _router: Router,
    private _ngbModal: NgbModal) {
    this.commonService = _commonService;
  }

  ngOnInit() {
    this.user = this._commonService.getUser();
    this.userPref = this._commonService.getUserPreference();
    let ctrlAccessLevel = this._commonService.getAccessLevel(environment.accessGroupKey);
    if (ctrlAccessLevel && ctrlAccessLevel.AccessKey == 'WIMSADM') {
      this.IsAdmin = true;
    }

    if (this.userPref && this.userPref.CustomerId){
      this.getCustomer(this.userPref.CustomerId, this.userPref.CustomerName);
      this.onCustomerChange( {CustomerId: this.userPref.CustomerId, CustomerName: this.userPref.CustomerName},
        this.userPref.FacilityId,this.userPref.FacilityName);
    }
    
    else
      this.getCustomer();
  }

  ngOnChanges() {
    this.loading = this.Loading;
  }

  ngOnDestroy() {
    if (this.facilityModalRef) {
      this.facilityModalRef.close();
    }
  }

  // getFacilities(defaultId = "", defaultName = "") {
  //   this.loading = true;
  //   console.time('getFacilities');
  //   this._dashboardService.getFacilities()
  //     .subscribe(response => {
  //       console.timeEnd('getFacilities');
  //       this.loading = false;
  //       if (response) {
  //         this.facilities = response;
  //         //used while loading from UserPreference
  //         if (defaultId) {
  //           this.selFacilityId = defaultId;
  //           this.selFacilityName = defaultName;
  //           this.onFacilityChange(null, this.userPref.CustomerId, this.userPref.CustomerName)
  //         }
  //         else{
  //           this.selFacilityId = this.facilities[0].FacilityId;
  //           this.selFacilityName = this.facilities[0].FacilityName;
  //         }
  //       }
  //     },
  //       error => {
  //         //Exception log
  //         console.timeEnd('getFacilities');
  //         console.log('getFacilities', error);
  //         this.loading = false;
  //       });
  // }

  getCustomer(defaultId = "", defaultName = "") {
    this.loading = true;

    this.customers = [];
    this.selCustomerId = "";
    this.selCustomerName = "";
    this.loading = true;
    console.time('getCustomers');
    this._dashboardService.getCustomers()
      .subscribe(response => {
        console.timeEnd('getCustomers');
        this.loading = false;
        if (response) {
          this.customers = response;
          if (defaultId) {
            this.selCustomerId = defaultId;
            this.selCustomerName = defaultName;
          }
          else {
            this.selCustomerId = this.customers[0].CustomerId;
            this.selCustomerName = this.customers[0].CustomerName;
          }
          
         
        }
      }, error => {
        //Exception log
        console.timeEnd('getCustomers');
        console.log('getCustomers', error);
        this.loading = false;
      });
  }

  Logout() {
    console.log('User Logged Out!');
    this._dashboardService.closeConnections();
    this._authService.logout();
    this._router.navigateByUrl("/login");
  }

  ChangeCustomer() {
    console.log('ChangeCustomer');
    let options: NgbModalOptions;
    options = {
      backdrop: "static",
      keyboard: false//,      
      //size: "sm"
    };
    this.userPref = this._commonService.getUserPreference();
    // if (this.userPref && this.userPref.CustomerId)
    //   this.getCustomer(this.userPref.CustomerId, this.userPref.CustomerName);

    this.facilityModalRef = this._ngbModal.open(this.facilityModal, options);
  }

  onFacilityChange(event) {
    console.log('onFacilityChange', event);
    if (event) {
      this.selFacilityId = event.FacilityId;
      this.selFacilityName = event.FacilityName;
    }
   
  }

  onCustomerChange(event, defaultId = "", defaultName = "") {
    console.log('onCustomerChange', event);
    if (event) {
      this.selCustomerId = event.CustomerId;
      this.selCustomerName = event.CustomerName;
    }
    if (this.selCustomerId) {
      this.facilities = [];
      this.selFacilityId = "";
      this.selFacilityName = "";
      this.loading = true;
      console.time('getFacility');
      this._dashboardService.getFacilities(this.selCustomerId)
        .subscribe(response => {
          console.timeEnd('getFacility');
          this.loading = false;
          if (response) {
            this.facilities = response;
            if (defaultId) {
              this.selFacilityId = defaultId;
              this.selFacilityName = defaultName;
            }
            else {
              this.selFacilityId = this.facilities[0].FacilityId;
              this.selFacilityName = this.facilities[0].FacilityName;
            }
          }
        }, error => {
          //Exception log
          console.timeEnd('getFacility');
          console.log('getFacility', error);
          this.loading = false;
        });
    }
  }

  SwitchCustomer() {
    this.loading = true;
    this._dashboardService.closeConnections();
    console.time('switchCustomer');
    this._dashboardService.switchCustomer(this.userPref.UserId, this.selFacilityId, this.selCustomerId)
      .subscribe(data => {
        console.timeEnd('switchCustomer');
        //console.log('switchCustomer', data);
        this.updatePreference();
        this.loading = false;
        this.FacilityChanged.emit({});
        this.facilityModalRef.close('Close');
      }, error => {
        //Exception log
        console.timeEnd('switchCustomer');
        console.log('switchCustomer', error);
        this.loading = false;
        this.facilityModalRef.close('Close');
      });

  }

  SaveAsDefault() {
    this.loading = true;
    this._dashboardService.closeConnections();
    console.time('updateDefaultDashboard');
    this._dashboardService.updateDefaultDashboard(this.userPref.UserId, this.selFacilityId, this.selCustomerId, true)
      .subscribe(data => {
        console.timeEnd('updateDefaultDashboard');
        //console.log('updateDefaultDashboard', data);
        this.updatePreference();
        this.loading = false;
        this.FacilityChanged.emit({});
        this.facilityModalRef.close('Close');
      }, error => {
        //Exception log
        console.timeEnd('updateDefaultDashboard');
        console.log('updateDefaultDashboard', error);
        this.loading = false;
        this.facilityModalRef.close('Close');
      });
  }

  updatePreference() {
    this.userPref.CustomerId = this.selCustomerId;
    this.userPref.CustomerName = this.selCustomerName;
    this.userPref.FacilityId = this.selFacilityId;
    this.userPref.FacilityName = this.selFacilityName;

    this._commonService.setUserPreference(this.userPref);
  }

  ClosePopup() {
    this.facilityModalRef.close('Close');
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/shared/header/header.component.ts